// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip_tooltip__QMGSL","tooltip-exit":"tooltip_tooltip-exit__9pFtx","text":"tooltip_text__BTxqS","measure":"tooltip_measure__pFKxB","line":"tooltip_line__AMLdT"};